<script>
  let { value, skeleton = false } = $props();

  // Get file type from filename
  const getFileType = (filename = "") => {
    if (!filename) return "Unknown";
    const ext = filename.split(".").pop() || "";
    return ext.toUpperCase();
  };
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <div>
    {getFileType(value)}
  </div>
{/if}
